// extracted by mini-css-extract-plugin
export default {"button":"ButtonGradient_button__ydYSq","icon":"ButtonGradient_icon__huXqL"};